import { createStyles, Grid, Theme, WithStyles, withStyles } from '@material-ui/core'
import moment from 'moment'
import React from 'react'
import TopLevelTarget from '../../Forms/FormTemplates/TopLevelTarget/TopLevelTarget'

import { createTargetsMapper } from 'src/utils/filters'
import { DateTarget, NumericTarget, StringTarget } from '../../services/Model/Addendum'

interface OutcomesProps extends WithStyles<typeof styles> {
	outcomes: any[]
}

interface OutcomesState {
	outcomes: Array<StringTarget | DateTarget | NumericTarget>
}

class Outcomes extends React.Component<OutcomesProps, OutcomesState> {
	public readonly state: OutcomesState = {
		outcomes: []
	}

	componentWillReceiveProps(nextProps: any) {
		this.setState({ outcomes: nextProps.outcomes })
	}

	async componentDidMount() {
		const actuals = this.props.outcomes
		this.setState({ outcomes: actuals })
	}

	targetFormatter = (targetObj: any) => {
		for (const key in targetObj) {
			if (targetObj.hasOwnProperty(key)) {
				if (targetObj[key] === 'NumericTarget') {
					return `${targetObj.actual} / ${targetObj.target}`
				} else if (targetObj[key] === 'DateTarget') {
					return moment(targetObj.date).format('MM/DD/YYYY')
				} else {
					return targetObj.target
				}
			}
		}
	}

	render() {
		const { classes } = this.props
		const { outcomes } = this.state
		const { topLevelTargets } = createTargetsMapper(outcomes)

		return (
			<div className={classes.root}>
				<section data-auto="activity-header">
					<Grid container={true} justify="flex-start">
						{topLevelTargets.map((topLevelTarget: any) => {
							return (
								<Grid item={true} className={classes.topLevelTarget} key={topLevelTarget.targetType}>
									<TopLevelTarget target={topLevelTarget.target}
										targetHeader={topLevelTarget.targetType}
										actual={topLevelTarget.actual} />
								</Grid>
							)
						})}
					</Grid>
				</section>
			</div>
		)
	}
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			margin: `0 8px`,
			padding: `4px 0`,
		},
		container: {},
		targetsHeader: {
			display: 'flex',
			justifyContent: 'space-between',
			paddingBottom: `${theme.spacing.unit * 2}px`,
		},
		topLevelTarget: {
			margin: `5px`,
		},
	})

export default withStyles(styles)(Outcomes)